import React, {useContext} from 'react';
import {Navigate, useLocation} from 'react-router-dom'
import RequireAuth from './RequireAuth';
import Spinner from '../components/Spinner/index';
import FirebaseContext from "../context/FirebaseContext";
import './Splash.scss';

function RequireSheet({ children, anonymous }) {
  const {profile, profileLoading} = useContext(FirebaseContext);
  let location = useLocation();

  // regardless of loading indicator, if we have a spreadsheetId, go ahead with content
  if (profile && profile.spreadsheetId) {
    return <RequireAuth>{children}</RequireAuth>
  }

  // Wait until their profile has loaded
  if (profileLoading) {
    return <div className="splash-screen">
      <Spinner />
    </div>
  } else if (!profile || !profile.spreadsheetId) {
    // If profile is loaded but no spreadsheetId is found...

    // Redirect them to the /get-started page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return anonymous || <Navigate to="/get-started" state={{ from: location }} replace />;
  }

  return <RequireAuth>{children}</RequireAuth>;
}
export default RequireSheet;
